import React from 'react';
import { Printer } from 'lucide-react';

const PrintBudgetButton = ({ className = '' }) => {
  const handlePrint = () => {
    const printWindow = window.open('', '_blank');
    const currentDate = new Date().toLocaleDateString('es-ES', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
    
    // Obtener el elemento a imprimir
    let printContent = document.querySelector('.budget-table-container').cloneNode(true);
    const yearElement = document.querySelector('.budget-info .info p:nth-child(2)');
    const year = yearElement ? yearElement.textContent : '';
    const subsidyElement = document.querySelector('.budget-info .custom-select__single-value');
    const subsidy = subsidyElement ? subsidyElement.textContent : 'Todas las subvenciones';
    
    // Crear el HTML para impresión
    printWindow.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <title>Reporte de Presupuesto PME</title>
          <style>
            body {
              font-family: Arial, sans-serif;
              font-size: 10px;
              margin: 0;
              padding: 10px;
              width: 100%;
              box-sizing: border-box;
            }

            .header-info {
              margin-bottom: 10px;
              color: #5664D2;
            }

            .header-info p {
              margin: 3px 0;
              font-size: 10px;
            }

            table {
              width: 100%;
              border-collapse: collapse;
              margin-bottom: 20px;
              font-size: 9px;
              table-layout: fixed;
            }

            caption {
              font-weight: bold;
              margin-bottom: 8px;
              color: #5664D2;
              font-size: 11px;
              text-align: left;
            }

            th, td {
              border: 1px solid #ddd;
              padding: 6px 4px;
              height: 20px;
              line-height: 1.2;
              overflow: hidden;
            }

            th {
              background-color: #5664D2 !important;
              color: white !important;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              font-size: 9px;
              vertical-align: middle;
              text-align: center;
              white-space: normal;
              height: 45px;
            }

            td {
              vertical-align: middle;
              white-space: nowrap;
              text-overflow: ellipsis;
            }

            /* Anchos fijos y alineaciones para cada columna */
            th:nth-child(1), td:nth-child(1) { 
              width: 3%; 
              text-align: center;
            }  /* N° */
            
            th:nth-child(2), td:nth-child(2) { 
              width: 8%; 
              text-align: left;
            }  /* Establecimiento */
            
            th:nth-child(3), td:nth-child(3) { 
              width: 12%; 
              text-align: right;
            }  /* Saldo anterior */
            
            th:nth-child(4), td:nth-child(4) { 
              width: 12%; 
              text-align: right;
            }  /* Total subvención */
            
            th:nth-child(5), td:nth-child(5) { 
              width: 12%; 
              text-align: right;
            }  /* Gastos operacionales */
            
            th:nth-child(6), td:nth-child(6) { 
              width: 12%; 
              text-align: right;
            }  /* Gastos remuneracionales */
            
            th:nth-child(7), td:nth-child(7) { 
              width: 12%; 
              text-align: right;
            }  /* Total gastos */
            
            th:nth-child(8), td:nth-child(8) { 
              width: 12%; 
              text-align: right;
            }  /* Saldo por rendir */
            
            th:nth-child(9), td:nth-child(9) { 
              width: 8%; 
              text-align: right;
            }   /* % Cumplimiento */
            
            th:nth-child(10), td:nth-child(10) { 
              width: 9%; 
              text-align: right;
            } /* % Remuneraciones */

            th {
              background-color: #5664D2 !important;
              color: white !important;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              font-size: 9px;
              vertical-align: middle;
            }

            .totals-row {
              background-color: rgba(86, 100, 210, 0.1) !important;
              font-weight: bold;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
            }

            .footer {
              position: fixed;
              bottom: 0;
              left: 0.5cm;
              right: 0.5cm;
              padding: 5px 0;
              border-top: 1px solid #ddd;
              font-size: 8px;
              color: #666;
              background-color: white;
              display: flex;
              justify-content: center;
            }

            @media print {
              @page {
                size: landscape;
                margin: 0.5cm;
                margin-bottom: 1cm;
              }

              table {
                page-break-inside: avoid;
              }

              .footer {
                position: fixed;
                bottom: 0;
              }
            }
          </style>
        </head>
        <body>
          <div class="header-info">
            <p><strong>Año:</strong> ${year}</p>
            <p><strong>Tipo de Subvención:</strong> ${subsidy}</p>
            <p><strong>Fecha:</strong> ${currentDate}</p>
          </div>
          ${printContent.outerHTML}
          <div class="footer">
            <span>Informe creado: ${currentDate}</span>
          </div>
          <script>
            window.onload = () => {
              setTimeout(() => {
                window.print();
                window.onafterprint = () => window.close();
              }, 500);
            };
          </script>
        </body>
      </html>
    `);
    
    printWindow.document.close();
  };

  return (
    <button
      onClick={handlePrint}
      className='btn-inform flex'
      title="Imprimir reporte"
    >
      <Printer color="white" size={20} />
      <p>Imprimir Reporte</p>
    </button>
  );
};

export default PrintBudgetButton;